import { SiteInfo2, SITE_INFO_TYPE } from '~/models/SiteInfo'

type UrlStrategy = (locale: string) => string

export class SiteInfoService {
	locale: string
	destinationName: string

	constructor(locale: string, destinationName: string) {
		this.locale = locale
		this.destinationName = destinationName
	}

	public static sortByType(info: SiteInfo2[]): SiteInfo2[] {
		const infoOrder = Object.values(SITE_INFO_TYPE)
		const sortedInfo = info.sort(
			(a: SiteInfo2, b: SiteInfo2) => infoOrder.indexOf(a.type!) - infoOrder.indexOf(b.type!)
		)
		return sortedInfo
	}

	public urlCorrelation(): Partial<Record<SITE_INFO_TYPE, string>> {
		return {
			[SITE_INFO_TYPE.DOCUMENTATION]: 'https://www.ivisa.com/?utm_source=passporterapp',
			[SITE_INFO_TYPE.MONEY]: 'https://revolut.ngih.net/Dyedd2',
			[SITE_INFO_TYPE.TRANSPORT]: `https://www.discovercars.com/${this.locale}?a_aid=passporterapp&data1=microsite&data2=${this.destinationName}`,
			[SITE_INFO_TYPE.HEALTH_AND_SAFETY]: this.obtainUrlFrom(this.locale),
			[SITE_INFO_TYPE.CONNECTIVITY]: 'https://holafly.sjv.io/XmL1g4',
		}
	}

	public obtainUrlFrom(locale: string): string {
		const strategy = this.localeStrategies[locale]
		return strategy ? strategy(locale) : this.defaultUrl
	}
	private readonly defaultUrl =
		'https://heymondo.es/?utm_medium=Afiliado&utm_source=PASSPORTER&utm_campaign=PRINCIPAL&cod_descuento=PASSPORTER&ag_campaign=ENTRADA&agencia=TmQ6oVUdKUtb48XOjACNv0Y0djarI5oI6wsdlQr5'

	private readonly queryParams =
		'?utm_source=Affiliates&utm_medium=Affiliates&utm_campaign=General&utm_term=67a2405de05f4&utm_content=67a2405de05f4'

	private readonly localeStrategies: Record<string, UrlStrategy> = {
		es: () =>
			`https://www.intermundial.es/afiliados/seguros-de-viaje-recomendado${this.queryParams}`,
		pt: () =>
			`https://www.intermundial.pt/afiliados/seguro-de-viagem-recomendado${this.queryParams}`,
		it: () => `https://www.intermundial.it/affiliates/assicurazione-viaggio${this.queryParams}`,
	}
}
